import { Pipe, PipeTransform } from '@angular/core';
import { declarationAppUrls, notificationAppUrls } from '../app.routes';

@Pipe({
  name: 'applicationDownloadPdfActionName',
  standalone: true
})
export class ApplicationDownloadPdfActionNamePipe implements PipeTransform {

  transform(value?: string | null): string {
    switch (true) {
      case declarationAppUrls.includes(value || ''): {
        return 'Pobierz deklaracje PDF';
      }
      case notificationAppUrls.includes(value || ''): {
        return 'Pobierz zgłoszenie PDF';
      }
      default: {
        return 'Pobierz wniosek PDF';
      }
    }
  }

}
